import { createFileRoute, useRouter } from "@tanstack/react-router";

import { PublicOfferConnector } from "@pages/public-offer";

export const Route = createFileRoute("/_private/public-offer")({
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const toVerification = () => {
    router.navigate({
      search: {
        tab: "verify",
      },
      to: "/profile",
    });
  };

  return (
    <PublicOfferConnector
      onGoBack={toVerification}
      onSuccess={toVerification}
    />
  );
}
